Service = App.loadClass 'core::Angular/Service'

class exports.BulkDeleteService extends Service
    constructor: (@http, @modal, @state) ->
        @active = false
        @buttonText = ''
        @buttonIcon = ''
        @selected = []
        @unselectedClass = 'success'
        @selectedClass = 'error'
        # initialize button
        @updateButtonInfo()

    updateButtonInfo: () =>
        # default to inactive information
        @buttonText = 'Delete'
        @buttonIcon = 'fa-trash-alt'

        if @active
            @buttonText = 'Cancel Deletion'
            @buttonIcon = 'fa-remove'

        # overwrite default information if bulk delete is active
        if @active and @selected.length
            @buttonText = 'Delete Selected'
            @buttonIcon = 'fa-trash-alt'

    toggle: (fieldprints) =>
        @fieldprints = fieldprints

        if @active
            @deactivate()
            return

        @activate()

    deactivate: () =>
        # first check if we need to delete anything
        if @selected.length
            @deleteSelected()

        # deactivate bulk delete mode
        @active = false

        @selected = []
        @setRowClasses()
        @updateButtonInfo()

    activate: () =>
        # turn on bulk delete mode
        @active = true
        @updateButtonInfo()

    setRowClasses: (selected = false) =>
        for row in @fieldprints
            row.selected_for_delete = selected

    selectRow: (row, fieldprints) =>
        # add or remove row from selected depending on if it was already selected or not
        if row.selected_for_delete
            @selected.splice(@selected.indexOf(row), 1)
        else
            @selected.push row

        # toggle the boolean property
        row.selected_for_delete = not row.selected_for_delete

        @updateButtonInfo()

    deleteSelected: () =>
        dialog = @launchDialog({ multiple: @selected.length > 1, selected: @selected })

        dialog.result.then (response) =>
            # reload the state to refresh the list of fieldprints
            @state.go 'grower.fieldprint', null, reload: 'grower.fieldprint'

    launchDialog: (resolve) =>
        @modal.open
            windowClass: 'sm_dialog'
            templateUrl: 'backend/grower/fieldprint/bulk-delete'
            controller: 'Fieldprint.Controllers.BulkDeleteController'
            resolve:
                'Data': () =>
                    return resolve
